import * as React from 'react';
import DashboardLayout from '../../../layout/DashboardLayout';
import CollaboratorMenu from './sideMenu/CollaboratorMenu';
import { SerializedStyles } from '@emotion/core';


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
};


/**
 * CollaboratorLayout: a component that renders the root layout of collaborator pages with the side menu containing a
 * a dev plan link and the main content area. Pass your collaborator view page content as this component's children.
 */
const CollaboratorLayout: React.FC<Props> = props => (
  <DashboardLayout {...props} menu={<CollaboratorMenu />}>
    {props.children}
  </DashboardLayout>
);

export default CollaboratorLayout;
